import React, { useEffect } from 'react';
import { css, Box } from '@dna/react';
import noImage from '../../../images/no-picture.png';
import { useAsync } from '../async';
import { patientService } from '../../../services/medicationmanagement/patientApi/PatientApi';
import { LoadingPlaceholder } from '@communicare/medications/Components/Placeholder';


export function ResidentImage<T>(props: { imageWidth: any, imageHeight: any; authoringSystem: any; authoringSystemForeignKey: any; }) {

    let { inProgress, success, error, queryDispatcher } = useAsync();
   
        useEffect(() => {
            if (!success?.data) {
                queryDispatcher(patientService.getPatientPhoto(props.authoringSystem, props.authoringSystemForeignKey));
            }
        }, []);

    if (inProgress) {
        return <Box
            css={{
                width: 50,
                height: 50
            }}
        >
            <LoadingPlaceholder size={30} />
        </Box>;
    }

    if (!success?.data) {
        return (
            <img width={props.imageWidth} height={props.imageHeight} src={noImage}></img>
        );
    }

    return (
        <img width={props.imageWidth} height={props.imageHeight} src={`data:image/png;base64,${success.data}`}></img>
    );
}

